<template>
  <div id="app">
    <!-- Global Toast Notification -->
    <div class="toast toast-top toast-center" style="z-index: 9999">
      <div
        v-if="toast.show"
        :class="`alert ${toast.type === 'success' ? 'alert-success' : 'alert-error'}`"
      >
        <span>{{ toast.message }}</span>
      </div>
    </div>
    <div class="redirect-box" v-if="showRedirect">
      <h1>You are being redirected...</h1>
    </div>
    <NavbarAdmin v-if="userLoggedIn" />
    <Navbar v-if="$route.name !== 'login'" />
    <router-view
      :class="{ 'view-height': $route.name !== 'home' }"
      class="pb-5"
    />
    <SqwervFooter v-if="$route.name !== 'login'" />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { useToast } from './composables/useToast'
import Navbar from './components/Navbar.vue'
import NavbarAdmin from './components/NavbarAdmin.vue'
import SqwervFooter from './components/SqwervFooter.vue'

const store = useStore()
const route = useRoute()
const { toast } = useToast()

const showRedirect = ref(false)

const userLoggedIn = computed(() => store.state.userLoggedIn)

onMounted(() => {
  if (route.query.redirect) {
    showRedirect.value = true
  }
})
</script>

<style>
.view-height {
  min-height: 86vh;
}
.required label:first-child:after {
  content: '*';
  color: red;
  font-size: 0.8rem;
}
.redirect-box {
  position: absolute;
  z-index: 1000;
  right: 0;
  left: 0;
  text-align: center;
  height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 34px;
}
</style>
